<template>
  <div class="card shadow-lg mt-5 border-0 max-width" style="padding: 20px;">
    <div class="card-body p-1">
      <h4
        class="card-title mb-3 text-dark text-uppercase"
        style="font-weight: 700"
      >
        <span style="color: #9ccc65">Petty Cash</span> Login
      </h4>
      <form @submit.prevent="login">
        <div class="flex-column">
          <label>Username </label></div>
        <div class="inputForm">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <input placeholder="Enter your Username" class="input" type="text" v-model="form.username">
        </div>

        <div class="flex-column">
          <label>Password </label></div>
        <div class="inputForm">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
          <input placeholder="Enter your Password" class="input" :type="passwordType" v-model="form.password">
        </div>
        <div>
          <div class="form-check form-switch my-1">
            <input class="form-check-input" type="checkbox" role="switch" id="showPassword" v-model="show_password">
            <label class="form-check-label" for="showPassword">Show Password</label>
          </div>
        </div>

        <button class="btn btn-success" type="submit" :disabled="loading">
          <div
            class="spinner-border"
            style="width: 2rem; height: 2rem"
            role="status"
            v-if="this.loadingText === 'Loading...'"
          ></div>
          <span role="status" class="ps-4">{{ this.loadingText }}</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
// import jwt from 'jwt-simple';

export default {
  name: "userLogin",
  data() {
    return {

      form: {
        username: "",
        password: "",
      },
      loading: false,
      showPass: false,
      show_password: false,
    };
  },
  computed: {
    passType() {
      return this.showPass ? "text" : "password";
    },
    passwordType() {
      return this.show_password ? 'text' : 'password';
    },
    loadingText() {
      return this.loading ? "Loading..." : "Login";
    },
  },
  methods: {
    login() {
      console.log(this.form);
      this.loading = true;
      localStorage.setItem('form', JSON.stringify(this.form));
      return this.$store.dispatch("validateUser", this.form)
          .then((result)=> {
            const sessionId = new Date().getTime();

            console.log(sessionId);
            localStorage.setItem('session_id', sessionId);
            this.$emit('login-success');
            // if (result.role === `Super_User`) return this.$router.push({ name : `Dashboard` })
            return this.$router.push({ name : `otp` })
          }).finally(() => this.loading = false)
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  max-width: 400px;
  width: 95vw;
  position: relative;
  background: rgba(255, 255, 255, 0.5); /* Slightly opaque background */
  backdrop-filter: blur(8px); /* Subtle blur for the frosted effect */
}

button {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  span{
  font-size: 1.3rem;

  }
}


.login-btn {
  color: white;
  display: block;
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 5px;
  box-shadow: 0 7px 18px rgba(11, 102, 255, 0.3) !important;

}

.form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #ffffff;
  padding: 5px;
  width: 450px;
  border-radius: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

@media screen and (max-width: 767px) {
  .card {
    padding-left: 10px;
    padding-right: 10px;
    width: 95%;

    margin-top: -3rem !important;
  }
  .form {
    width: 100%;
  }
}

::placeholder {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}



.flex-column > label {
  color: #151717;
  font-weight: 600;
}

.inputForm {
  border: 1.5px solid #ecedec;
  border-radius: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  transition: 0.2s ease-in-out;
}

.input {
  margin-left: 10px;
  border-radius: 10px;
  border: none;
  width: 100%;
  height: 100%;
}

.input:focus {
  outline: none;
}

.inputForm:focus-within {
  border: 1.5px solid #198752;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}

.flex-row > div > label {
  font-size: 14px;
  color: black;
  font-weight: 400;
}

.span {
  font-size: 14px;
  margin-left: 5px;
  color: #2d79f3;
  font-weight: 500;
  cursor: pointer;
}


.p {
  text-align: center;
  color: black;
  font-size: 14px;
  margin: 5px 0;
}
</style>
